/* eslint-disable no-console */
import React from 'react';
import { useIntl } from 'react-intl';

import { GoogleLogin } from '../google-login';
// refresh token
import refreshTokenSetup from '../../Utils/RefreshTokenSetup';

// eslint-disable-next-line react/prop-types
const Login = function Login({ setUser }) {
  const intl = useIntl();

  const onSuccess = (res) => {
    setUser(res.profileObj.email);
    refreshTokenSetup(res);
  };

  const onFailure = (res) => {
    // eslint-disable-next-line no-console
    console.log('Login failed: res:', res);
    // eslint-disable-next-line no-alert
    alert(intl.messages.LOGIN_FAILED);
  };

  return (
    <div>
      <GoogleLogin
        // eslint-disable-next-line no-undef
        clientId={CLIENT_ID}
        // eslint-disable-next-line no-undef
        apiKey={API_KEY}
        // eslint-disable-next-line no-undef
        discoveryDocs={[DISCOVERY_DOCS]}
        // eslint-disable-next-line no-undef
        scope={SCOPES}
        buttonText="Login"
        onSuccess={onSuccess}
        onFailure={onFailure}
        cookiePolicy="single_host_origin"
        style={{ marginTop: '100px' }}
        isSignedIn
      />
    </div>
  );
};

export default Login;
